import { ResumeAnalysis } from "../resume-analysis/resume-analyse-types";
import { getMistakesInStatement } from "../statment-analysis-scoring/countMistakesInStatement";
import { PersonalDetailsScoreAnalysis } from "../types";



export const getPersonalDetailsScore = (profile: ResumeAnalysis["profile"], maxScoreOfSection: number): PersonalDetailsScoreAnalysis => {

  let statementMistakeCount = 0;
  let informationMistakeCount = 0;
  let linkMistakeCount = 0;
  let totalMistakeCount = 0;
  
  if (!profile.name) {
    informationMistakeCount++;
  }
  if (!profile.email) {
    informationMistakeCount++;
  }
  if (!profile.phone) {
    informationMistakeCount++;
  }
  // if (profile.summaryAnalysis.statement === "") {
  //   informationMistakeCount++;
  // }
  if (!profile.url1 && !profile.url2) {
    linkMistakeCount++;
  }
  if (!profile.location) {
    informationMistakeCount++;
  }


  // statementMistakeCount += getMistakesInStatement(profile.summaryAnalysis.analysis);
  const getCriticalIssuesCount = () => {
    let count = 0;
    if (profile.summaryAnalysis.statement == "") {count++ ;return count};
    count += profile.summaryAnalysis.analysis.grammarMistakes.length;
    count += profile.summaryAnalysis.analysis.spellingMistakes.length;
    count += profile.summaryAnalysis.analysis.buzzWords.length;
    count += profile.summaryAnalysis.analysis.personalPronouns.length
    return count;
  };

  statementMistakeCount += getCriticalIssuesCount();
  
  totalMistakeCount = statementMistakeCount + informationMistakeCount + linkMistakeCount;

  // Check if profile is completely empty - return 0 score but keep mistake counts for UI
  const hasAnyContent = Boolean(
    (profile.name && String(profile.name).trim()) ||
    (profile.email && String(profile.email).trim()) ||
    (profile.phone && String(profile.phone).trim()) ||
    (profile.location && String(profile.location).trim()) ||
    (profile.url1 && String(profile.url1).trim()) ||
    (profile.url2 && String(profile.url2).trim()) ||
    (profile.summaryAnalysis?.statement && String(profile.summaryAnalysis.statement).trim())
  );

  if (!hasAnyContent) {
    return {
      totalScore: 0,
      statementMistakeCount,
      informationMistakeCount,
      linkMistakeCount,
      totalMistakeCount
    };
  }

  let totalScore = maxScoreOfSection;

  if (totalMistakeCount > 0 && totalMistakeCount <= 3) {
    totalScore -= 0.1 * maxScoreOfSection;
  } else if (totalMistakeCount > 3 && totalMistakeCount <= 6) {
    totalScore -= 0.25 * maxScoreOfSection;
  } else if (totalMistakeCount > 6 && totalMistakeCount <= 12) {
    totalScore -= 0.4 * maxScoreOfSection;
  } else if (totalMistakeCount > 12 && totalMistakeCount <= 18) {
    totalScore -= 0.6 * maxScoreOfSection;
  } else if (totalMistakeCount > 18) {
    totalScore -= 0.8 * maxScoreOfSection;
  }


  return {
    totalScore: totalScore,
    statementMistakeCount,
    informationMistakeCount,
    linkMistakeCount,
    totalMistakeCount
  };

}
